import { Box, Button, Grid, Paper, Tab, Tabs } from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { addDays, format, isAfter, subDays } from "date-fns";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import AuthService from "../../../AuthService";
import utils from "../../../utils";
import Template from "../../Generico/Template";
import TituloPrincipal from "../../Generico/TituloPrincipal";
import ReportSaleCustomer from "./Report";

export default function CustomerSalesByType() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [filter, setFilter] = useState({
    dataInicial: subDays(new Date(), 2),
    dataFinal: addDays(new Date(), 1),
  });
  const [loading, setLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [orderList, setOrderList] = useState([]);

  const handleChangeTab = (event, newValue) => {
    setSelectedTab(newValue);
  };

  function handleChangeDate(date, name) {
    if (!date || isNaN(date)) return;
    setFilter({ ...filter, [name]: date });
  }

  const organizarPedidosPorPessoa = (orderList) => {
    if (!orderList || orderList.length === 0) {
      enqueueSnackbar("Nenhum pedido encontrado no período informado", {
        variant: "warning",
      });
      return;
    }

    let pedidosDelivery = [];
    let pedidosQrcode = [];

    orderList.forEach((order) => {
      let hash = "";

      if (order.pessoa) {
        hash = order.pessoa.nome + utils.onlyDigits(order.pessoa.telefone);
      } else {
        hash = order.nomeCliente + utils.onlyDigits(order.telefone);
      }

      hash = hash.replaceAll(" ", "").toLowerCase();

      if (order.tipoPedido === "DELIVERY") {
        let customer = pedidosDelivery.find((e) => e.hash === hash);

        if (!customer) {
          customer = {
            quantityTakeWay: 0.0,
            quantityDelivery: 0.0,
            dataUltimoPedido: order.createdAt,
            orderList: [],
          };

          if (order.pessoa) {
            customer.name = order.pessoa.nome;
            customer.phone = order.pessoa.telefone;
            customer.hash = hash;
          }
        }

        customer.orderList.push(order);

        if (
          isAfter(
            new Date(order.createdAt),
            new Date(customer.dataUltimoPedido)
          )
        ) {
          customer.dataUltimoPedido = order.createdAt;
        }

        customer.value = utils.getTotalPedido(order) + (customer.value || 0);
        customer.quantity = 1 + (customer.quantity || 0);

        if (order.tipoDelivery === "RETIRAR_LOCAL") {
          customer.quantityTakeWay++;
        } else {
          customer.quantityDelivery++;
        }

        let index = pedidosDelivery.findIndex((e) => e.hash === hash);
        if (index < 0) {
          pedidosDelivery.push(customer);
        } else {
          pedidosDelivery[index] = customer;
        }
      } else {
        let customer = pedidosQrcode.find((e) => e.hash === hash);

        if (!customer) {
          customer = {
            name: order.nomeCliente,
            phone: order.telefone,
            hash: hash,
            orderList: [],
            value: 0.0,
            quantity: 0.0,
            quantityTakeWay: 0.0,
            quantityDelivery: 0.0,
          };
        }

        customer.orderList.push(order);
        customer.value += utils.getTotalPedido(order);
        customer.quantity++;

        let index = pedidosQrcode.findIndex((e) => e.hash === hash);
        if (index < 0) {
          pedidosQrcode.push(customer);
        } else {
          pedidosQrcode[index] = customer;
        }
      }
    });

    setOrderList({
      pedidosDelivery,
      pedidosQrcode,
    });
  };

  const onClickBuscar = () => {
    setOrderList([]);

    const diff = Math.abs(
      filter.dataInicial.getTime() - filter.dataFinal.getTime()
    );
    const days = Math.ceil(diff / (1000 * 60 * 60 * 24));

    if (days > 30) {
      enqueueSnackbar("A diferença máxima entre as datas deve ser de 30 dias", {
        variant: "warning",
      });
      return;
    }

    setLoading(true);

    const dataInicialStr = `${format(
      filter.dataInicial,
      "yyyy-MM-dd"
    )} 00:00:00`;
    const dataFinalStr = `${format(filter.dataFinal, "yyyy-MM-dd")} 00:00:00`;

    const query = `dataInicial=${encodeURIComponent(
      dataInicialStr
    )}&dataFinal=${encodeURIComponent(dataFinalStr)}&max=5000`;

    const service = new AuthService();

    service
      .get(`/pedido/find?${query}`)
      .then((respPedidos) => organizarPedidosPorPessoa(respPedidos))
      .catch((err) => {
        console.error(err);
        enqueueSnackbar("Falha ao listar os pedidos.", { variant: "error" });
      })
      .finally(() => setLoading(false));
  };

  return (
    <Template>
      <TituloPrincipal
        title="Vendas por cliente"
        subTitle="As vendas serão classificadas pela origem"
      />
      <Paper>
        <Box p={2}>
          <Grid container spacing={2} alignItems="center">
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={3}>
                  <DatePicker
                    label="Período inicial"
                    format="dd/MM/yyyy"
                    value={filter.dataInicial}
                    onChange={(date) => handleChangeDate(date, "dataInicial")}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        margin: "dense",
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <DatePicker
                    label="Período final"
                    format="dd/MM/yyyy"
                    value={filter.dataFinal}
                    onChange={(date) => handleChangeDate(date, "dataFinal")}
                    slotProps={{
                      textField: {
                        fullWidth: true,
                        size: "small",
                        margin: "dense",
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </LocalizationProvider>
            <Grid
              size={{
                xs: 6,
                md: 2,
              }}
            >
              <Button
                fullWidth
                disabled={loading}
                variant="contained"
                color="primary"
                onClick={onClickBuscar}
              >
                {loading ? "Buscando..." : "Buscar"}
              </Button>
            </Grid>
          </Grid>

          <Tabs
            value={selectedTab}
            onChange={handleChangeTab}
            variant="standard"
            indicatorColor="secondary"
            textColor="secondary"
          >
            <Tab label="Delivery" value={0} />
            <Tab label="QrCode" value={1} />
          </Tabs>

          {selectedTab === 0 ? (
            <ReportSaleCustomer
              orderList={orderList.pedidosDelivery}
              filename={`delivery_${format(
                filter.dataInicial,
                "yyyy-MM-dd"
              )}_${format(filter.dataFinal, "yyyy-MM-dd")}.csv`}
            />
          ) : (
            <ReportSaleCustomer
              orderList={orderList.pedidosQrcode}
              filename={`qrcode_${format(
                filter.dataInicial,
                "yyyy-MM-dd"
              )}_${format(filter.dataFinal, "yyyy-MM-dd")}.csv`}
            />
          )}
        </Box>
      </Paper>
    </Template>
  );
}
